var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPaymentVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45.6667,
    height: 31,
    rx: 5.5,
    fill: "white",
    stroke: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.167 21.6775H11.3399L9.21994 13.5897C9.11932 13.2177 8.90566 12.8888 8.59139 12.7337C7.80708 12.3442 6.94282 12.0342 6 11.8778V11.5664H10.5542C11.1828 11.5664 11.6542 12.0342 11.7328 12.5774L12.8327 18.4114L15.6584 11.5664H18.407L14.167 21.6775ZM19.9783 21.6775H17.3083L19.5069 11.5664H22.1769L19.9783 21.6775ZM25.6312 14.3683C25.7097 13.8237 26.1811 13.5123 26.7311 13.5123C27.5954 13.4341 28.5368 13.5905 29.3225 13.9787L29.7939 11.8017C29.0082 11.4903 28.144 11.334 27.3597 11.334C24.7683 11.334 22.8826 12.7345 22.8826 14.6783C22.8826 16.157 24.2183 16.9335 25.1611 17.4012C26.1811 17.8676 26.574 18.179 26.4954 18.6454C26.4954 19.345 25.7097 19.6564 24.9254 19.6564C23.9826 19.6564 23.0398 19.4232 22.1769 19.0336L21.7055 21.2119C22.6483 21.6001 23.6683 21.7565 24.6111 21.7565C27.5168 21.8333 29.3225 20.4341 29.3225 18.334C29.3225 15.6893 25.6312 15.5343 25.6312 14.3683ZM38.6666 21.6775L36.5467 11.5664H34.2695C33.7981 11.5664 33.3267 11.8778 33.1696 12.3442L29.2439 21.6775H31.9924L32.541 20.2002H35.9181L36.2324 21.6775H38.6666ZM34.6625 14.291L35.4468 18.1017H33.2483L34.6625 14.291Z",
    fill: "#172B85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPaymentVisa);
export default __webpack_public_path__ + "static/media/ic-payment-visa.109b14aed932158ac7234f73d053261d.svg";
export { ForwardRef as ReactComponent };